import { useProfileStore } from 'Store/Profile'
import { generateImageUrl } from 'Utils/generateImageUrl'
import { shallow } from 'zustand/shallow'

/* eslint-disable jsx-a11y/anchor-is-valid */
const AsideToolbar = () => {
	const { profile } = useProfileStore(
		state => ({
			profile: state.userProfile,
		}),
		shallow
	)

	return (
		<>
			{/*begin::User*/}
			<div className="aside-user d-flex align-items-sm-center justify-content-center py-5 border-0">
				{/*begin::Symbol*/}
				<div className="symbol symbol-50px">
					<img
						className="rounded-circle"
						src={
							profile?.pictureProfilePath
								? generateImageUrl(profile?.pictureProfilePath)
								: '/media/icons/kumopack/default-placeholder.png'
						}
						onError={(e: any) => {
							e.target.onerror = null
							e.target.src = '/media/icons/kumopack/default-placeholder.png'
						}}
						alt="Supplier User Profile"
					/>
				</div>
				{/*end::Symbol*/}

				{/*begin::Wrapper*/}
				<div className="aside-user-info flex-row-fluid flex-wrap ms-5">
					{/*begin::Section*/}
					<div className="d-flex">
						{/*begin::Info*/}
						<div className="flex-grow-1 me-2">
							{/*begin::Username*/}
							<a href="#" className="text-hover-primary fs-6 fw-bold" style={{ color: '#344054' }}>
								{profile?.fullnameTh}
							</a>
							{/*end::Username*/}

							{/*begin::Description*/}
							<span className="fw-bold d-block fs-8 mb-1" style={{ color: '#475467' }}>
								({String(profile?.fullnameEn) && profile?.fullnameEn ? profile?.fullnameEn : '-'})
							</span>
							{/*end::Description*/}
						</div>
						{/*end::Info*/}
					</div>
					{/*end::Section*/}
				</div>
				{/*end::Wrapper*/}
			</div>
			{/*end::User*/}
		</>
	)
}

export { AsideToolbar }
